import { render, staticRenderFns } from "./DiagnosticHistoryForm.vue?vue&type=template&id=8bd3577a&"
import script from "./DiagnosticHistoryForm.vue?vue&type=script&lang=js&"
export * from "./DiagnosticHistoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports